import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router'
import Layout from '@/components/Layout.vue'
import BrandSelection from '@/components/BrandSelection.vue'
import Login from '@/components/auth/Login.vue'
import Register from '@/components/auth/Register.vue'
import AssetDetails from '@/components/AssetDetails.vue'
import { apiClient } from '@/services/api'

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    meta: { requiresAuth: true },
  },
  {
    path: '/assets/:id',
    name: 'AssetDetails',
    component: AssetDetails,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: '/brand-selection',
    name: 'BrandSelection',
    component: BrandSelection,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { requiresAuth: false },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard to check authentication
router.beforeEach(async (to: RouteLocationNormalized, _from: RouteLocationNormalized, next) => {
  // Public routes that don't require authentication
  const publicRoutes = ['/login', '/register']
  const isPublicRoute = publicRoutes.includes(to.path)

  // If accessing a public route, allow access
  if (isPublicRoute) {
    next()
    return
  }

  // For protected routes, check authentication
  try {
    // Try to get current user
    await apiClient.getCurrentUser()

    const selectedBrandId = localStorage.getItem('selectedBrandId')
    const requiresBrandSelection = to.path !== '/brand-selection' && to.path !== '/login' && to.path !== '/register'

    if (requiresBrandSelection && !selectedBrandId) {
      next({
        path: '/brand-selection',
        query: { redirect: to.fullPath },
      })
      return
    }

    // User is authenticated, allow access.
    next()
  } catch (error) {
    // User is not authenticated, redirect to login
    // Store the intended destination for redirect after login
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
  }
})

export default router
